import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.board.detail');
import { OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-board-detail',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.board.detail/view.scss */
:host {
  display: block;
  width: 100%;
  height: 100%;
}`],
})
export class PortalBoardDetailComponent implements OnInit {
    @Input() postId: string = '';
    @Output() onBack = new EventEmitter<void>();
    @Output() onEdit = new EventEmitter<string>();

    public loading: boolean = false;
    public post: any = null;
    public comments: any[] = [];
    public newComment: string = '';
    public replyTo: string = '';
    public replyContent: string = '';
    private submitting: boolean = false;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.load();
    }

    public async load() {
        if (!this.postId) return;
        this.loading = true;
        await this.service.render();

        const params = new URLSearchParams();
        params.append('post_id', this.postId);

        try {
            const res = await fetch('/api/board/post-get', { method: 'POST', body: params });
            const result = await res.json();
            if (res.ok) {
                this.post = result.data;
                this.comments = result.data?.comments || [];
            }
        } catch (e) { }

        this.loading = false;
        await this.service.render();
    }

    public goBack() {
        this.onBack.emit();
    }

    public editPost() {
        this.onEdit.emit(this.postId);
    }

    public async deletePost() {
        const confirmed = await this.service.modal.show({
            title: '게시물 삭제',
            message: '이 게시물을 삭제하시겠습니까?',
            action: '삭제', cancel: '취소', actionBtn: 'error', status: 'error'
        });
        if (!confirmed) return;

        const params = new URLSearchParams();
        params.append('post_id', this.postId);
        try {
            const res = await fetch('/api/board/post-delete', { method: 'POST', body: params });
            if (res.ok) {
                this.goBack();
            }
        } catch (e) { }
    }

    public async addComment() {
        if (!this.newComment.trim() || this.submitting) return;
        this.submitting = true;

        const params = new URLSearchParams();
        params.append('post_id', this.postId);
        params.append('content', this.newComment);

        try {
            const res = await fetch('/api/board/comment-create', { method: 'POST', body: params });
            if (res.ok) {
                this.newComment = '';
                await this.load();
            }
        } catch (e) { }

        this.submitting = false;
    }

    public async addReply(parentId: string) {
        if (!this.replyContent.trim() || this.submitting) return;
        this.submitting = true;

        const params = new URLSearchParams();
        params.append('post_id', this.postId);
        params.append('content', this.replyContent);
        params.append('parent_id', parentId);

        try {
            const res = await fetch('/api/board/comment-create', { method: 'POST', body: params });
            if (res.ok) {
                this.replyContent = '';
                this.replyTo = '';
                await this.load();
            }
        } catch (e) { }

        this.submitting = false;
    }

    public async deleteComment(commentId: string) {
        const params = new URLSearchParams();
        params.append('comment_id', commentId);
        try {
            await fetch('/api/board/comment-delete', { method: 'POST', body: params });
            await this.load();
        } catch (e) { }
    }

    public toggleReply(commentId: string) {
        this.replyTo = this.replyTo === commentId ? '' : commentId;
        this.replyContent = '';
    }
}

export default PortalBoardDetailComponent;